import $$ from 'dom7';
import Framework7 from './framework7-custom.js';

// Import F7 Styles
import '../css/framework7-custom.less';
import '../css/custom.css';
import '../fonts/iranSans/iranSans.css';

// Import Icons and App Custom Styles
import '../css/icons.css';
import '../css/app.less';
// Import Cordova APIs
import cordovaApp from './cordova-app.js';
// Import Routes
import routes from './routes.js';

var app = new Framework7({
  root: '#app', // App root element
  id: 'app.appkhone.com', // App bundle ID
  name: 'اپخونه', // App name
  theme: 'md', // Automatic theme detection
  // App root data
  data: function () {
    return {
      user: {
        firstName: 'John',
        lastName: 'Doe',
      },

    };
  },
  // App root methods
  methods: {
    helloWorld: function () {
      app.dialog.alert('Hello World!');
    },
  },
  // App routes
  routes: routes,
  // Enable panel left visibility breakpoint
  panel: {
    leftBreakpoint: 960,
  },

  // Register service worker
  serviceWorker: Framework7.device.cordova ? {} : {
    path: '/service-worker.js',
  },
  // Input settings
  input: {
    scrollIntoViewOnFocus: Framework7.device.cordova && !Framework7.device.electron,
    scrollIntoViewCentered: Framework7.device.cordova && !Framework7.device.electron,
  },
  // Cordova Statusbar settings
  statusbar: {
    overlay: Framework7.device.cordova && Framework7.device.ios || 'auto',
    iosOverlaysWebView: true,
    androidOverlaysWebView: false,
  },
  on: {
    init: function () {
      onDeviceReady();

      var f7 = this;
      if (f7.device.cordova) {
        // Init cordova APIs (see cordova-app.js)
        cordovaApp.init(f7);
      }
    },
  },
});

// Login Screen Demo
$$('#my-login-screen .login-button').on('click', function () {
  var username = $$('#my-login-screen [name="username"]').val();
  var password = $$('#my-login-screen [name="password"]').val();

  // Close login screen
  app.loginScreen.close('#my-login-screen');

  // Alert username and password
  app.dialog.alert('Username: ' + username + '<br>Password: ' + password);
});


//appWebLoad

//document.addEventListener("deviceready", onDeviceReady , false);
$$(document).on('page:init', '.page[data-name="HomePage"]', function (e, page) {
  //console.log('1');


});

$$(document).on('page:init',  '.page[data-name="HomePage"]',function (e, page) {
  //console.log('1');
  onDeviceReady();
});


//onDeviceReady();

function onDeviceReady() {
  //console.log('1');

  var xhttp2 = new XMLHttpRequest();
  xhttp2.onreadystatechange = function() {
    //console.log(this);
    if(this.readyState > 0 && this.readyState < 4){
    } else if (this.readyState == 4 && this.status == 200) {
      var serverResult = this.responseText ;

      document.getElementById('GetTabs').innerHTML = serverResult;
      // Now safe to use device APIs
      var swiperHeadAppSet = app.swiper.create('#sliderHeadApp', {
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
        },
        autoplay: {
          delay: 5000,
        },
        spaceBetween: 5,
        observer: true,
        observeParents: true,
        nested:true,
      });
      var swiperHeadApp = app.swiper.get('#sliderHeadApp');
      swiperHeadApp.init();

      var swiperHeadGameSet = app.swiper.create('#sliderHeadGame', {
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
        },
        autoplay: {
          delay: 5000,
        },
        spaceBetween: 5,
        observer: true,
        observeParents: true,
        nested:true,
      });
      var swiperHeadGame = app.swiper.get('#sliderHeadGame');
      swiperHeadGame.init();

      getMenuAndPopups();
      getNews();
      checkUpadte();
      //Sliders
    }
  };
  xhttp2.open("GET", "https://appkhoneh.ir/server/?page=homeTabs&did="+localStorage.getItem('DID'), true);
  xhttp2.send();


  window.setInterval(function(){
    /// call your function here
    checkUpadte();
  }, 5000);
}
//appWebLoad

function getMenuAndPopups() {
  var xhttp2 = new XMLHttpRequest();
  xhttp2.onreadystatechange = function() {
    if(this.readyState > 0 && this.readyState < 4){
    } else if (this.readyState == 4 && this.status == 200) {
      var serverResult = this.responseText ;
      document.getElementById('mypopups').innerHTML = serverResult;
      checkIsWebApp();
    }
  };
  xhttp2.open("GET", "https://appkhoneh.ir/server/?page=menuAndPopups", true);
  xhttp2.send();
}

function getNews() {
  var xhttp2 = new XMLHttpRequest();
  xhttp2.onreadystatechange = function() {
    if(this.readyState > 0 && this.readyState < 4){
    } else if (this.readyState == 4 && this.status == 200) {
      var serverResult = this.responseText ;
      document.getElementById('newsapp').innerHTML = serverResult;
    }
  };
  xhttp2.open("GET", "https://appkhoneh.ir/server/?page=news", true);
  xhttp2.send();
}

function checkUpadte(){
  //console.log(localStorage);
  var xhttp2 = new XMLHttpRequest();
  xhttp2.onreadystatechange = function() {
    if(this.readyState > 0 && this.readyState < 4){
    } else if (this.readyState == 4 && this.status == 200) {
      var serverResult = this.responseText ;
      var obj = JSON.parse(serverResult);
      document.getElementById("userOnline").innerHTML=obj.Profile;

      if (localStorage.getItem('DID') === null || localStorage.getItem('DID') == ''){
        localStorage.setItem('DID',obj.did);
      }
      if (obj.ver != document.getElementById('webappVer').innerText){
        document.getElementById('updateNotif').style.display = '';
        document.getElementById('updateNotif').innerText = obj.text;
      }else {
        document.getElementById('updateNotif').style.display = 'none';
      }
        //console.log(localStorage.getItem('DID'));
        //console.log(localStorage);
      userIsOnline(obj);
    }
  };
  if (localStorage.getItem('DID') === null || localStorage.getItem('DID') == ''){
    xhttp2.open("GET", "https://appkhoneh.ir/server/?page=update&newDID=1", true);
  } else {
    xhttp2.open("GET", "https://appkhoneh.ir/server/?page=update&DID="+localStorage.getItem('DID'), true);
  }
  xhttp2.send();
}

function userIsOnline(obj) {
  var user = localStorage.getItem('userOnline');
  //console.log(localStorage);
  if (localStorage.getItem('userOnline') === null || localStorage.getItem('userOnline') == '') {

  }else{
    document.getElementById("userOffline").style.display='none';
    document.getElementById("userOnline").style.display='';
    document.getElementById("userPhone").innerHTML=localStorage.getItem('userPhone');
  }
}

function checkIsWebApp() {
  var isInWebAppiOS = (window.navigator.standalone == true);
  var isInWebAppChrome = (window.matchMedia('(display-mode: standalone)').matches);

  if (device.model == 'Chrome' && isInWebAppChrome === false ){
    var installPopup = app.popup.create({
      el: '.install-android-popup',
      swipeToClose: true,
    });
    installPopup.open(true);
  }
  if (device.model == 'Safari' && isInWebAppiOS === false ){
    var installPopup = app.popup.create({
      el: '.install-ios-popup',
      swipeToClose: true,
    });
    installPopup.open(true);
  }
}

function photoGallary(photos) {
  var photoArray = photos.split(',');
  for (var i = 0; i < photoArray.length; i++) {
    if (photoArray[i] == '') {
      photoArray.splice(i, 1);
      i--;
    }
  }
  //console.log(app.photoBrowser);

  var myPhotoBrowserStandalone = app.photoBrowser.create({
    photos : photoArray ,
    backLinkText : 'بازگشت',
    navbarOfText : 'از',
    swipeToClose : 'true',
    navbar: 'false',
    toolbar : 'false',
    type: 'popup',
    theme: 'dark',


  });
  myPhotoBrowserStandalone.open();
}

$$(document).on('click', '.photoGallary', function (e) {
  var photos = document.getElementById('appPhotos').innerText;
  photoGallary(photos);
});



$$(document).on('page:init',  '.page[data-name="appPage"]',function (e, page) {
  var appid = page.route.params.appId;
  var xhttp2 = new XMLHttpRequest();
  xhttp2.onreadystatechange = function() {
    if(this.readyState > 0 && this.readyState < 4){
    } else if (this.readyState == 4 && this.status == 200) {
      var serverResult = this.responseText ;
      //document.getElementsByClassName('appshow').innerHTML = "ok";
      //document.getElementById('appshow').innerHTML = serverResult;
      var xapppages =document.getElementsByClassName("appshow");  // Find the element
      //console.log(xapppages);
      var newpage= xapppages.length;
      //xapppages[newpage].innerHTML = serverResult;
      for(var i = 0; i < xapppages.length; i++){
        xapppages[i].innerHTML = serverResult;    // Change the content
      }
    }
  };
  xhttp2.open("GET", "https://appkhoneh.ir/server/?page=app&id="+appid, true);
  xhttp2.send();
});

$$(document).on('page:init',  '.page[data-name="sPage"]',function (e, page) {
  var openpage = page.route.params.page;
  var title = page.route.params.title;
   
  var xhttp2 = new XMLHttpRequest();
  xhttp2.onreadystatechange = function() {
    if(this.readyState > 0 && this.readyState < 4){
    } else if (this.readyState == 4 && this.status == 200) {
      var serverResult = this.responseText ;
      document.getElementById("sPage").innerHTML = serverResult;  // Find the element
      if (title !== undefined || title !==null) {
        document.getElementById('spageTitle').innerHTML = title ;
      }
    }
  };
  xhttp2.open("GET", "https://appkhoneh.ir/server/?page="+openpage+"&title="+title, true);
  xhttp2.send();
});

$$(document).on('page:init',  '.page[data-name="appList"]',function (e, page) {
  document.getElementById('AppListName').innerHTML = page.route.params.catName;
  var type = page.route.params.apptype;
  var cat = page.route.params.catId;
  getAppList(type,cat,0);
  $$(document).on('infinite', '.infinite-scroll-content', function (e) {
    //var nextFrom = $$('.divAppList li').length;
    //getAppList(type,cat,nextFrom);
    $$('.infinite-scroll-preloader').remove();

  });

});

function getAppList(type,cat,from) {
  //console.log("https://appkhoneh.ir/server/?page=appList&type="+type+"&cat="+cat+"&from="+from);
  var xhttp2 = new XMLHttpRequest();
  xhttp2.onreadystatechange = function() {
    if(this.readyState > 0 && this.readyState < 4){
    } else if (this.readyState == 4 && this.status == 200) {
      var serverResult = this.responseText ;
      var myAppList = document.getElementById('myAppList').innerHTML;
      document.getElementById('myAppList').innerHTML = myAppList + serverResult;
      if (serverResult == ''){
        $$('.infinite-scroll-preloader').remove();
      }
    }
  };
  xhttp2.open("GET", "https://appkhoneh.ir/server/?page=appList&type="+type+"&cat="+cat+"&from="+from, true);
  xhttp2.send();
}


